import Notifications from '@kyvg/vue3-notification'

export default defineNuxtPlugin({
	parallel: true,
	async setup(nuxtApp) {
		nuxtApp.vueApp.use(Notifications, {})
	}
});
